import React, { useState, useEffect } from 'react';
import useSetState from '../../../hooks/useSetState';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Spin from '../../../components/loading';
import Table from '../../../components/table';
import { packagesListColumns } from '../../../enums/columns/packagesList';
import { getAllRseePackagesRequest } from '../../../redux/rseePackages/actions';

const PackagesManagement = props => {
  let dispatch = useDispatch();

  const [controls, setControls] = useSetState({
    sort: { sortType: 'desc', sortBy: 'price', sortQuery: '', filterQuery: '' },
    pageNumber: 1,
    pageSize: 10,
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const { rseePackagesList, rseePackagesTotalRecords, getRseePackagesListLoading } = useSelector(state => ({
    rseePackagesList: state.rseePackagesReducer.rseePackagesList,
    rseePackagesTotalRecords: state.rseePackagesReducer.rseePackagesTotalRecords,
    getRseePackagesListLoading: state.rseePackagesReducer.getRseePackagesListLoading,
  }));

  const sortTable = (columnName) => {
    const sortType = controls.sort.sortType === 'asc' ? 'desc' : 'asc';
    onChangeValue('sort', { ...controls.sort, sortType, sortBy: columnName });
  };

  const onPageChanged = pageNumber => {
    onChangeValue('pageNumber', pageNumber);
    let query = `pageNumber=${pageNumber}&pageSize=${controls.pageSize}`;
    dispatch(getReservationTimingList(query));
  };

  useEffect(() => {
    const query = `pageNumber=${controls.pageNumber}&pageSize=${controls.pageSize}`;
    dispatch(getAllRseePackagesRequest(query));
  }, []);

  return (
    <Spin>
      <section>
        <div className="page-header">
          <h1>{locales('packages.management')}</h1>
          <div className="form-actions">
            <Link to="/packages/management/add-or-edit-package"
              className="btn btn-primary mx-1">
              <i className="fa fa-plus mx-1" />
              {locales('add.new.package')}
            </Link>
          </div>
        </div>

        <div className='bg-white p-2'>
          <div className="panel-heading">
            <i className="fas fa-list-alt px-1" />
            {locales('packages.list')}
          </div>
          <div className='table-responsive-lg'>
            <Table
              columns={packagesListColumns}
              dataSource={rseePackagesList}
              loading={getRseePackagesListLoading}
              sort={{ type: controls.sort.sortType, action: sortTable }}
              pagination={{
                currentPage: controls.pageNumber,
                pageSize: controls.pageSize,
                totalCount: rseePackagesTotalRecords || 0,
                onPageChange: onPageChanged,
              }}
            />
          </div>
        </div>
      </section>
    </Spin>)
};

export default PackagesManagement;